import { EditCompanyBusinessNameOutDto, EditCompanyBusinessNameInDto } from '../../../types/company.dto'

export const EDIT_COMPANY_BUSINESS_NAME = 'EDIT_COMPANY_BUSINESS_NAME'
export const EDIT_COMPANY_BUSINESS_NAME_SUCCESS = 'EDIT_COMPANY_BUSINESS_NAME_SUCCESS'
export const EDIT_COMPANY_BUSINESS_NAME_ERROR = 'EDIT_COMPANY_BUSINESS_NAME_ERROR'
export const RESET_EDIT_COMPANY_BUSINESS_NAME = 'RESET_EDIT_COMPANY_BUSINESS_NAME'

export interface EditCompanyBusinessName {
  type: typeof EDIT_COMPANY_BUSINESS_NAME
  payload: EditCompanyBusinessNameOutDto
}

export interface EditCompanyBusinessNameSuccess {
  type: typeof EDIT_COMPANY_BUSINESS_NAME_SUCCESS
  payload: EditCompanyBusinessNameInDto
}

export interface EditCompanyBusinessNameError {
  type: typeof EDIT_COMPANY_BUSINESS_NAME_ERROR
  payload: string | boolean
}

export interface ResetEditCompanyBusinessName {
  type: typeof RESET_EDIT_COMPANY_BUSINESS_NAME
  payload: null
}
export interface State {
  data: EditCompanyBusinessNameInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = EditCompanyBusinessName | EditCompanyBusinessNameSuccess | EditCompanyBusinessNameError | ResetEditCompanyBusinessName
